import Reveal from "@/components/Reveal";

/**
 * Editorial section heading. `align` left|center. `dark` for dark sections.
 */
export default function SectionHeading({
  eyebrow,
  title,
  subtitle,
  align = "left",
  dark = false,
  as = "h2",
  className = "",
}) {
  const Tag = as;
  const alignCls = align === "center" ? "text-center mx-auto items-center" : "text-left items-start";
  return (
    <Reveal className={`flex flex-col ${alignCls} ${align === "center" ? "max-w-2xl" : "max-w-3xl"} ${className}`}>
      {eyebrow && (
        <span className={`eyebrow mb-4 ${dark ? "text-blush" : "text-rose"}`}>
          {eyebrow}
        </span>
      )}
      <Tag
        className={`text-4xl sm:text-5xl lg:text-[3.5rem] ${dark ? "text-white" : "text-ink"}`}
      >
        {title}
      </Tag>
      {subtitle && (
        <p
          className={`mt-5 text-base md:text-lg leading-relaxed ${
            dark ? "text-white/70" : "text-ink/70"
          } ${align === "center" ? "max-w-xl" : "max-w-2xl"}`}
        >
          {subtitle}
        </p>
      )}
      <span className={`mt-6 block h-px w-16 ${dark ? "bg-blush/70" : "bg-rose"}`} aria-hidden="true" />
    </Reveal>
  );
}
